import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { consumer } from '@tock/coretypes';
import { useActions } from 'utils/connect';
import { useCallback } from 'react';

interface GetBaseFormFieldsOptions {
  widgetToEdit?: consumer.NamedConfiguration;
}

export const getBaseFormFieldsInitialValues = (
  options?: GetBaseFormFieldsOptions
): BaseWidgetFormFields => {
  const widgetToEdit = options?.widgetToEdit;

  return { name: widgetToEdit ? widgetToEdit.name : '' };
};

export const useFetchAllCollectionConfigurations = () => {
  const { actions } = useActions();

  return useCallback(() => {
    actions.consumerPage.fetchAllCollectionDataConfigurations();
  }, [actions.consumerPage]);
};

export const useUpdateNamedConfigurations = () => {
  const { actions } = useActions();

  return async (config: consumer.INamedConfiguration) => {
    await actions.consumerPage.updateNamedConfiguration(config);
    await actions.consumerPage.fetchAllNamedConfigurations();
  };
};

export const useCreateNamedConfigurations = () => {
  const { actions } = useActions();

  return async (config: consumer.INamedConfiguration) => {
    await actions.consumerPage.createNamedConfiguration(config);
    await actions.consumerPage.fetchAllNamedConfigurations();
  };
};
